import { render, staticRenderFns } from "./SuggestListComp.vue?vue&type=template&id=02c5f5ce&scoped=true"
import script from "./SuggestListComp.vue?vue&type=script&lang=js"
export * from "./SuggestListComp.vue?vue&type=script&lang=js"
import style0 from "./SuggestListComp.vue?vue&type=style&index=0&id=02c5f5ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c5f5ce",
  null
  
)

export default component.exports